module.exports = __webpack_public_path__ + "images/blue_highlight.6916669a38bd0bf5b39b332dae908a81.png";